import { useAuth } from '@frontend/context/authContext';
import { useState, useEffect, useMemo } from 'react';
import getClient, { setClientRecreationCallback } from './client';

const useClient = () => {
  const { token } = useAuth();
  const [clientKey, setClientKey] = useState(0);

  // Create client with unique key to force recreation
  const client = useMemo(() => {
    return getClient({ token });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, clientKey]);

  // Register recreation callback on mount
  useEffect(() => {
    const recreateCallback = () => {
      setClientKey((prev) => prev + 1);
    };

    setClientRecreationCallback(recreateCallback);

    // Cleanup on unmount
    return () => {
      setClientRecreationCallback(() => {
        // No-op cleanup function
      });
    };
  }, []);

  return client;
};

export default useClient;
